// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expire-info[data-v-26ede9bc]{display:-webkit-box;display:-ms-flexbox;display:flex;color:#fff;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;height:inherit}.expire-info .day[data-v-26ede9bc]{font-size:40px;font-weight:500;margin:0 5px;-ms-flex-item-align:end;align-self:end}.prefix-label[data-v-26ede9bc]{line-height:1;text-align:right}.prefix-label[data-v-26ede9bc],.suffix-label[data-v-26ede9bc]{font-size:12px}", ""]);
// Exports
module.exports = exports;
